import constate from 'constate';
import { useCallback, useState } from 'react';

const useAgGridCellUpdate = () => {
  const [updatingCells, setUpdatingCells] = useState<Set<string>>(new Set());

  const setUpdating = useCallback((nodeId: string, colId: string, isUpdating: boolean) => {
    const cellKey = `${nodeId}-${colId}`;
    setUpdatingCells((prev) => {
      const updated = new Set(prev);

      isUpdating ? updated.add(cellKey) : updated.delete(cellKey);

      return updated;
    });
  }, []);

  const isUpdating = useCallback(
    (nodeId: string, colId: string) => {
      const cellKey = `${nodeId}-${colId}`;

      return updatingCells.has(cellKey);
    },
    [updatingCells]
  );

  return {
    updatingCells,
    setUpdating,
    isUpdating,
  };
};

export const [AgGridCellUpdateProvider, useAgGridCellUpdateContext] = constate(useAgGridCellUpdate);
